<template>
    <div>
        <!-- :show-select="can('orders.edit')" -->
        <v-data-table
            :single-select="false"
            item-key="id"
            :headers="headers"
            :items="evictions"
            hide-default-footer
            disable-pagination
            @toggle-select-all="$emit('toggle-select-all', $event)"
            @item-selected="$emit('item-selected', $event)"
        >
            <template v-slot:item.file_date="{ item }">
                {{ item.file_date }}
                <v-chip
                    small
                    class="ml-1"
                    color="error"
                    dark
                    v-if="item.filtered"
                    >Filtered</v-chip
                >
            </template>
            <template v-slot:item.address="{ item }">
                {{ $_.get(item, "record.addresses[0].street") }}<br />
                {{ $_.get(item, "record.addresses[0].city")
                }}<span v-if="$_.get(item, 'record.addresses[0].city')">,</span>
                {{ $_.get(item, "record.addresses[0].state") }}
                {{ $_.get(item, "record.addresses[0].zip") }}
            </template>
            <template v-slot:item.source="{ item }">
                <v-chip label class="text-uppercase" color="accent">{{
                    item.source
                }}</v-chip>
            </template>

            <template v-slot:item.matched="{ item }">
                <v-switch
                    v-if="can('orders.edit')"
                    class="mt-n2"
                    :label="item.matched ? 'Matched' : 'No Match'"
                    :value="item.mached"
                    hide-details
                    color="accent"
                ></v-switch>
                <span v-else>
                    {{ item.matched ? "Matched" : "No Match" }}
                </span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        evictions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "File Date",
                    align: "start",
                    sortable: true,
                    value: "file_date",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Source",
                    align: "start",
                    sortable: true,
                    value: "source",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Match",
                    align: "start",
                    sortable: true,
                    value: "matched",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },

                {
                    text: "Name",
                    align: "start",
                    sortable: true,
                    value: "case.fullName",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Address",
                    align: "start",
                    sortable: true,
                    value: "address",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
</style>